import modalBox from '../components/modal-box.vue'
import formContact from '../components/form-contact.vue'
import blickComp from '../components/blick-comp.vue'
import {canSendMessage} from '../helpers/vuexFixes'

export default {
  name: 'call-to-action',
  components: {
    modalBox,
    formContact,
    blickComp,
  },
  data(){
    return {
      modalOpenedQty: 0,
      modalClosedQty: 0,
    }
  },
  methods: {
    processModalClosing(){
      this.modalClosedQty+=1;
      
      //очистить форму только после того как модалка будет закрыта
      //анимация модалки сделана на css-transitions поэтому время подобрано "на глаз"
      setTimeout(()=>{
        this.$refs.formContact.reset();
      },250)
    },
    processModalOpening(){
      this.modalOpenedQty+=1;
      this.$refs.formContact.processOpening();
    },
    processFormResponse(){
      // окно закрывается через 6 секунд после показа сообщения об отправке или об ошибке отправки.
      let localModalOpenedQty = this.modalOpenedQty 
      setTimeout(()=>{
        
        if (
          // если после получения ответа модалка не открывалась ещё раз
          this.modalOpenedQty == localModalOpenedQty
        ) 
        {
          this.$refs.modalWithContactForm.close();
        }
      },6000)
    }
  },
  mounted(){
    this.$root.$data.showBlick$
      //todo в фильтр добавить canSend из vuex. WTF? Я уже не помню о чем здесь речь. 
      .filter(data=> {
        let res;
        res = (data.to == 'btn-contact' && canSendMessage())
        return res;
      })
      .throttleTime(5000)
      .subscribe(data=>{
        this.$refs.blick.animate();
      })
  }
}



// WEBPACK FOOTER //
// ./src/includes/CallToAction.js